import { z } from "zod";

export enum EModulatorPingStatus {
  OK = "OK",
  NOK = "NOK",
  UNREACHABLE = "UNREACHABLE",
}

export const modulatorPingDtoSchema = z.nativeEnum(EModulatorPingStatus);

export type TModulatorPingDto = z.infer<typeof modulatorPingDtoSchema>;
